import { createFileRoute } from "@tanstack/react-router";
import Navbar from "@/components/Navbar";
import CityHeroShared from "@/components/CityHeroShared";
import CityMap from "@/components/CityMap";
import CityUseCases from "@/components/CityUseCases";
import MobileBookNowFab from "@/components/MobileBookNowFab";
import VehicleTypeIcons from "@/components/VehicleTypeIcons";
import FleetMeatSection, { ReviewsSection } from "@/components/FleetMeatSection";
import SprinterSpecsSection from "@/components/SprinterSpecsSection";
import SeoLongform from "@/components/SeoLongform";
import GeoAnswerBlock from "@/components/GeoAnswerBlock";
import { STERLINGHEIGHTS_MI_REVIEWS } from "@/data/reviews/sterlingheights_mi";
import { cityHeadMeta } from "@/data/citySeo";

export const Route = createFileRoute("/sterlingheights-mi")({
  component: CityLanding,
  head: () => ({
    meta: [
      ...cityHeadMeta("sterlingheights-mi"),
      { property: "og:image", content: "https://sprinter-van-rentals.com/__l5e/assets-v1/d9d070c6-6676-46c4-b0f4-9b0498e3c905/van-lot-og.jpg" },
      { property: "twitter:image", content: "https://sprinter-van-rentals.com/__l5e/assets-v1/d9d070c6-6676-46c4-b0f4-9b0498e3c905/van-lot-og.jpg" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://sprinter-van-rentals.com/sterlingheights-mi" }],
  }),
});

function CityLanding() {
  return (
    <main className="min-h-screen bg-white text-[#0F172A]">
      <Navbar />
      <MobileBookNowFab />
      <CityHeroShared
        citySlug="sterlingheights-mi"
        cityLabel="Sterling Heights"
        headline={"Sterling Heights\nSprinter Van Rentals"}
        intro="Sterling Heights Sprinter van rentals seating 12 and 15 passengers with full luggage space — delivered across Sterling Heights and the surrounding Detroit metro area."
      />
<section id="fleet" className="max-w-[1440px] mx-auto px-6 pt-12 md:pt-16 pb-24 scroll-mt-24">
        <div className="mb-10">
          <p className="font-display font-bold text-xs uppercase tracking-[0.4em] mb-3 text-[#F97316]">Sterling Heights Sprinter Van Rentals</p>
          <h2 className="font-display font-black text-5xl md:text-6xl tracking-tight text-[#0F172A]">
            Choose a 12 or 15 seat Sprinter in Sterling Heights.
          </h2>
        </div>
        <VehicleTypeIcons accent="#F97316" citySlug={"sterlingheights-mi" as never} />
      </section>

      <CityMap citySlug={"sterlingheights-mi" as never} accent="#F97316" />
      <ReviewsSection city="sterlingheights-mi" accent="#F97316" dark accentSecondary="#FFB347" reviewCity="Sterling Heights" reviews={STERLINGHEIGHTS_MI_REVIEWS} />
      <SprinterSpecsSection city="sterlingheights-mi" accent="#F97316" />
      <FleetMeatSection city="sterlingheights-mi" accent="#F97316" dark accentSecondary="#FFB347" reviewCity="Sterling Heights" />
      <SeoLongform citySlug="sterlingheights-mi" />
      <GeoAnswerBlock citySlug="sterlingheights-mi" />
      <CityUseCases citySlug={"sterlingheights-mi" as never} accent="#F97316" />
      <footer className="py-8 text-center border-t border-[#0F172A]/8">
        <p className="text-[#0F172A]/50 text-xs tracking-widest uppercase">&copy; 2026 Sprinter Van Rentals · Sterling Heights</p>
      </footer>
    </main>
  );
}
